import useAppQuery from 'core/query-client/useAppQuery';
import { getCountries } from 'shared/api/countries/http';

const useCountriesQuery = () =>
  useAppQuery('countries', getCountries, {
    cacheTime: Infinity,
    refetchOnMount: false
  });

export default useCountriesQuery;
